var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "lineup--template schedule--template relative" },
          [
            _c("div", {
              staticClass: "db fixed top-0 bottom-0 w-100 vh-100 bg-cream z-2",
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "dn db-ns fixed top-0 bottom-0 w-100 vh-100 bg-cream-pink-split-before z-3 before-ml24-ns top-0-ns",
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "db dn-ns absolute is-black z-4000 bg-cream mobile-menu-lineup",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative flex flex-row items-center w-100 h3 bb-grey container-fluid",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex w-100 flex-row justify-between" },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "f25px is-tablet-cond-bold is-black pointer",
                            attrs: {
                              href: _vm.lineup_nav_links_published[
                                _vm.activeItemIndex
                              ].link,
                              title:
                                _vm.lineup_nav_links_published[
                                  _vm.activeItemIndex
                                ].title,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.lineup_nav_links_published[
                                  _vm.activeItemIndex
                                ].title
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "w2 mt2 inline-flex pointer arrow-down-icon",
                            class: {
                              "is-clicked": _vm.mobileMenuIconIsClicked,
                            },
                            on: {
                              click: function ($event) {
                                _vm.mobileMenuIconIsClicked =
                                  !_vm.mobileMenuIconIsClicked
                              },
                            },
                          },
                          [
                            _c("simple-svg", {
                              staticClass: "green-arrow",
                              attrs: {
                                filepath: "/uploads/plus.svg",
                                id: "arrow-down-icon-id",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade-rev" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mobileMenuIconIsClicked,
                          expression: "mobileMenuIconIsClicked",
                        },
                      ],
                      staticClass: "absolute bg-cream w-100 z-4000",
                    },
                    _vm._l(
                      _vm.lineup_nav_links_published,
                      function (item, index) {
                        return index != _vm.activeItemIndex
                          ? _c(
                              "div",
                              {
                                key: item.title,
                                staticClass:
                                  "relative flex flex-row items-center w-100 h3 container-fluid",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "f25px is-tablet-cond-bold is-black pointer",
                                    attrs: {
                                      href: item.link,
                                      title: item.title,
                                    },
                                    on: {
                                      click: function ($event) {
                                        ;(_vm.activeItemIndex = index),
                                          (_vm.mobileMenuIconIsClicked =
                                            !_vm.mobileMenuIconIsClicked)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ]
                            )
                          : _vm._e()
                      }
                    ),
                    0
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "relative" }, [
              _c("div", { staticClass: "relative z-content" }, [
                _c(
                  "section",
                  { staticClass: "relative mw12 flex flex-row z-1" },
                  [
                    _vm.isWindowWidthMobile == true
                      ? _c("div", { staticClass: " w-100 dn-ns" }, [
                          _c("div", {
                            staticClass:
                              "container-fluid  relative z-4 overflow-hidden",
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWindowWidthMobile == false
                      ? _c(
                          "div",
                          { staticClass: "dn relative flex-ns flex-grow-1" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "w-100 mw-24rem pv5 pl5 minh-450",
                              },
                              [
                                _c("div", { staticClass: "h-100" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info-bg sticky-nav" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "pr5" },
                                        _vm._l(
                                          _vm.page.lineup_nav.links,
                                          function (item, key) {
                                            return item.is_published
                                              ? _c(
                                                  "div",
                                                  { staticClass: "pv2" },
                                                  [
                                                    _c(
                                                      "accordion",
                                                      {
                                                        attrs: {
                                                          index: key,
                                                          desktopActive:
                                                            _vm.desktopActive,
                                                        },
                                                        on: {
                                                          "update:desktopActive":
                                                            function ($event) {
                                                              _vm.desktopActive =
                                                                $event
                                                            },
                                                          "update:desktop-active":
                                                            function ($event) {
                                                              _vm.desktopActive =
                                                                $event
                                                            },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          {
                                                            slot: "parent-nav-link",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "f25px is-tablet-cond-bold is-black",
                                                                class: {
                                                                  active:
                                                                    _vm.desktopActive ==
                                                                    key,
                                                                },
                                                                attrs: {
                                                                  href: item.link,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.title
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "w-100 is-black" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ph6 mv5 b--is-orange bl bw1 z-4 relative negitive-margin",
                                },
                                [
                                  _c("div", { staticClass: "z-4 relative" }, [
                                    _vm.isWindowWidthMobile == false
                                      ? _c(
                                          "div",
                                          { staticClass: "relative vh-100" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "is-tablet-bold f4 is-black",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Build Your Schedule in the Outside Lands App available\n                        on\n                        "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "is-orange",
                                                    attrs: {
                                                      href: "https://apps.apple.com/us/app/outside-lands/id547295030",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v("iOS")]
                                                ),
                                                _vm._v(
                                                  "\n                        and\n                        "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "is-orange",
                                                    attrs: {
                                                      href: "https://play.google.com/store/apps/details?id=com.livestyled.outsidelands",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v("Android")]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                ref: "embedContainer",
                                                staticClass: "w-100",
                                                attrs: {
                                                  id: "dostuff-embed-container",
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  attrs: { id: "ds-fest" },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "db dn-ns fixed top-0 bottom-0 w-100 vh-100 bg-cream-tan-split-before z-3",
                style: {
                  top: 21 * _vm.lineup_nav_links_published.length + "px",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "db dn-ns relative container-fluid z-content" },
                [
                  _c("div", { staticClass: "relative pv5 vh-50" }, [
                    _c("p", { staticClass: "is-tablet-bold f4 is-black" }, [
                      _vm._v(
                        "\n              Build Your Schedule in the Outside Lands App available on\n              "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "is-orange",
                          attrs: {
                            href: "https://apps.apple.com/us/app/outside-lands/id547295030",
                            target: "_blank",
                          },
                        },
                        [_vm._v("iOS")]
                      ),
                      _vm._v("\n              and\n              "),
                      _c(
                        "a",
                        {
                          staticClass: "is-orange",
                          attrs: {
                            href: "https://play.google.com/store/apps/details?id=com.livestyled.outsidelands",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Android")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "embedContainer",
                        staticClass: "w-100",
                        attrs: { id: "dostuff-embed-container" },
                      },
                      [_c("div", { attrs: { id: "ds-fest" } })]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }